import React  from 'react';
import {Buttons} from '../../elements/ui/index';
import Ionicon from "react-ionicons";

export const Location = (props) => {
    const {profile_location, buttonHandlers, guestMode} = props;
    return (
        <div className="profile-location">
            { profile_location && profile_location.hasOwnProperty('name') &&
            <span className="user-info"><b>Currently based:</b> <br />{ profile_location.name }, { profile_location.country_name }</span> }
            {/*show when not in guestMode*/}
            { !guestMode && <Buttons.HOCButton
                text={ profile_location && profile_location.hasOwnProperty('name') ? <Ionicon icon="ion-edit"/> :
                    <em>Add location you are currently based at...</em>}
                icon=""
                { ...buttonHandlers }
            /> }
        </div>
    )
};

export default Location;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/header/Location.js